import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Component that scrolls to top when location changes
 * Used as a complement to the transition system
 */
const ScrollManager = () => {
  const { pathname } = useLocation();

  // Scroll to top whenever pathname changes
  useEffect(() => {
    // Immediately scroll to top of the page
    window.scrollTo({
      top: 0,
      behavior: "auto", // Use 'auto' for instant scroll without animation
    });
  }, [pathname]);

  // This component doesn't render anything
  return null;
};

export default ScrollManager;
